module.exports = __webpack_public_path__ + "static/img/4.ea616d64.png";